module.exports = __webpack_public_path__ + "img/B2.78328188.svg";